import * as firebase from 'firebase/app'
import 'firebase/firestore';
import { Store } from 'vuex';

export default {
  state: {
    menuItems:null,
    loading:false,
    currentEvent:null,
    currentEvents:null

  },
  mutations: {
    loading(state,payload){
      state.loading=payload
    },
    setMenuItems(state, payload) {
      state.menuItems = payload

    },
    addMenuItem(state, payload) {
      if(!state.menuItems){
        state.menuItems = []
      }
      state.menuItems.push(payload)
      console.log("state.menuItems")
    },
    setCurrentEvent(state,payload){
      state.currentEvent=payload
    },
    setCurrentEvents(state,payload){
      state.currentEvents=payload
    },
   addEvent(state,payload){
    state.currentEvents.push(payload)
    console.log("++++++++",state.currentEvents)
   }
    
   
  },
  actions: {
    loadEventsStatus({ dispatch, commit }) {
      var db = firebase.firestore();
      console.log("------",db)
      commit('loading',true)
      let doc
      let data
      var docRef=db.collection("website").doc("Events")
      docRef.get().then((doc) => {
        if (doc.exists) {
            console.log("Document dataXX:", doc.data());
            commit("setCurrentEvents",[])
            if(doc.data().Active && doc.data().ActiveEvents){
              console.log("Document dataXX:", doc.data().ActiveEvents);
              for(var event in doc.data().ActiveEvents){
                console.log("Document dataXXX:", doc.data().ActiveEvents[event]);
                dispatch("loadEvent",doc.data().ActiveEvents[event])
              }
            }
            // if(doc.data().Active && doc.data().TestEvents){
            //   console.log("Document dataXX:", doc.data().TestEvents);
            //   for(var event in doc.data().TestEvents){
            //     console.log("Document dataXXX2:",event, doc.data().TestEvents[event]);
            //     dispatch("loadEvent",doc.data().TestEvents[event])
            //   }
            // }
            
        } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
        }
    }).catch((error) => {
        console.log("Error getting document:", error);
    });
      
      
    },
    addEvent({ commit },payload) {
      var db = firebase.firestore();
      commit('loading',true)
      let doc
      let data
      var docRef=db.collection("Events").doc(payload)
      docRef.get().then((doc) => {
        if (doc.exists) {
            commit("addEvent",doc.data())
        } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
            commit('loading',false)
        }
    }).catch((error) => {
        console.log("Error getting document:", error);
        commit('loading',false)
    });
      
      
    },
    loadEvent({ commit },payload) {
      var db = firebase.firestore();
      console.log("------",db)
      commit('loading',true)
      let doc
      let data
      var docRef=db.collection("Events").doc(payload)
      docRef.get().then((doc) => {
        if (doc.exists) {
            console.log("Document data:::::", doc.data());
            commit("addEvent",doc.data())
        } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
        }
    }).catch((error) => {
        console.log("Error getting document:", error);
    });
      
      
    },
    loadMenuItems({ commit }) {
      var db = firebase.firestore();
      commit('loading',true)
      let doc
      let data
      console.log("----- Load menu items")
      var collRef=db.collection("website")
      console.log("----- ",collRef)
      commit('setMenuItems',[])
      collRef.get().then(function(coll){
        for(var d in coll.docs){
          doc.coll.docs[d]
          data=doc.data()
          console.log("MENU ITEMS",data)
          commit('addMenuItem',data)
        }
        commit('loading',false)
      }).catch(function(error){
        console.log("Error getting document:",error)
        commit('loading',false)
      })
      
      
    },
    
  },
  getters: {
    getCurrentEvent(state){
      return state.currentEvent
    },
    getCurrentEvents(state){
      return state.currentEvents
    }
    
  }
}


// WEBPACK FOOTER //
// ./src/store/website/index.js